import types from "./AuthTypes";

export const login = (payload) => {
  return { payload: payload, type: types.LOGIN };
};

export const logout = () => {
  return { type: types.LOGOUT };
};
